import script from "./Tools.vue?vue&type=script&setup=true&lang=ts"
export * from "./Tools.vue?vue&type=script&setup=true&lang=ts"

import "./Tools.vue?vue&type=style&index=0&id=fb863822&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb863822"]])

export default __exports__